// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"675":"89a60b0c","803":"64a99093"}[chunkId] + ".chunk.css";
};